import { ConfigJson } from "../config-json.ts";
import { CoralogixLogSeverity, CoralogixRum } from "@coralogix/browser";
import { log } from "../utilities/logger.ts";

export const accertifyDataCollector = async (
  DATA_COLLECTOR_URL: ConfigJson["ACCERTIFY_ENDPOINT"],
): Promise<any | { transactionId: string }> => {
  const windowRef: any = window;
  const start = performance.now();

  // Data Collector script
  const s = document.createElement("script");
  s.setAttribute("type", "text/javascript");
  s.setAttribute("src", DATA_COLLECTOR_URL);
  s.setAttribute("dvct", "500");
  s.setAttribute("sid", "test-session");
  s.setAttribute("id", "bcn");
  s.setAttribute("dvc", "l");
  s.onload = () => {
    if (
      windowRef.hasOwnProperty("_bcn") &&
      windowRef._bcn.hasOwnProperty("dvc")
    ) {
      windowRef._bcn.dvc.collect();
    }
  };
  document.head.appendChild(s);

  return new Promise((resolve) => {
    setTimeout(() => {
      let data;
      if (
        windowRef.hasOwnProperty("collector") &&
        windowRef.hasOwnProperty("_bcn") &&
        windowRef._bcn.hasOwnProperty("dvc")
      ) {
        data = windowRef.collector.getPayload(windowRef._bcn.dvc.getTID());
        const click = performance.now();
        log("Time elapsed " + (click - start) / 1000.0 + " seconds");
        CoralogixRum.log(
          CoralogixLogSeverity.Debug,
          "Accertify script Time elapsed " +
            (click - start) / 1000.0 +
            " seconds",
        );
      } else {
        CoralogixRum.log(
          CoralogixLogSeverity.Error,
          "Error collecting Accertify script",
        );
      }

      resolve(data);
    }, 500);
  });
};
